import React from 'react';

import AccountInfoHolder from '../AccountInfoHolder';

import { ServerCommunicationUtil } from '../../../utils/server_communication_util';

class AccountMergeInterface extends React.Component {
  constructor(props) {
    super(props);
    const emails = ['', ''];
    if (this.props.userId1) {
      emails[0] = this.props.userId1;
    }
    if (this.props.userId2) {
      emails[1] = this.props.userId2;
    }
    this.state = {
      // one search can return several accounts that are active/deleted, so this.state.users represents two sets of possible user accounts
      users: [[], []],
      emails,
      statusText: null,
      mergeComplete: false,
      finalUser: null
    };
  }

  componentDidMount() {
    if (this.props.userId1) {
      this.retrieveUser(0);
    }
    if (this.props.userId2) {
      this.retrieveUser(1);
    }
  }

  retrieveUser(userNumber) {
    const identifier = this.state.emails[userNumber];
    const options = {};
    if (identifier.indexOf('@') >= 0) {
      options.user_email = identifier;
    } else {
      const asNum = parseInt(identifier);
      if (!isNaN(asNum)) {
        options.user_id = identifier;
      } else {
        options.user_slug = identifier;
      }
    }

    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/admin/users/1',
      options,
      data => {
        const newUsers = this.state.users;
        // we want registered accounts to be first
        const sortedUsers = data.users.sort((a, b) => {
          return a.status < b.status;
        });
        newUsers[userNumber] = sortedUsers;
        this.setState({
          users: newUsers,
          mergeComplete: false,
          statusText: null
        });
      },
      () => {
        const errorObject = { error: 'Unable to locate user' };
        const newUsers = this.state.users;
        newUsers[userNumber] = [errorObject];

        this.setState({ users: newUsers });
      },
      () => {}
    );
  }

  mergeCheck() {
    if (!this.containsBothUsers()) {
      return false;
    }
    if (this.state.users[0][0].error || this.state.users[1][0].error) {
      return false;
    }
    if (this.state.users[0][0].pro) {
      if (this.state.users[1][0].pro) {
        window.alert('Merge is not possible, both accounts are pro.');
      } else {
        window.alert('Merge is not possible, please merge the non-pro account into the pro account.');
      }
      return false;
    }

    return true;
  }

  swapUsers = () => {
    // swap emails and users
    this.setState({ emails: this.state.emails.reverse(), users: this.state.users.reverse() });
  };

  userObjUpdated = (userId, userObj, innerIndex, outerIndex) => {
    // users are array of arrays
    const currentUsers = this.state.users;
    currentUsers[outerIndex][innerIndex] = userObj;
    this.setState({ users: currentUsers });
  };

  performSave = (userId, innerIndex, outerIndex) => {
    const toUpdate = { slug: this.state.users[outerIndex][innerIndex].slug };
    this.setState({ statusText: 'Save in progress...' });
    ServerCommunicationUtil.putApiEndpoint(
      `/api/alltrails/admin/users/${userId}`,
      toUpdate,
      data => {
        if (data && data.users) {
          const currentUsers = this.state.users;
          currentUsers[outerIndex] = data.users;
          this.setState({ users: currentUsers });
        }
        this.setState({ statusText: 'Save successful!' });
      },
      err => {
        err = JSON.parse(err.responseText);
        this.setState({ statusText: err.errors[0].message });
      },
      () => {}
    );
  };

  performUndelete = (userId, innerIndex, outerIndex) => {
    this.setState({ statusText: 'Undelete in progress...' });
    ServerCommunicationUtil.putApiEndpoint(
      `/api/alltrails/admin/users/${userId}/undelete`,
      {},
      data => {
        if (data && data.users) {
          const currentUsers = this.state.users;
          currentUsers[outerIndex] = data.users;
          this.setState({ users: currentUsers });
        }
        this.setState({ statusText: 'Undelete successful!' });
      },
      err => {
        this.setState({ statusText: 'Undelete failed.' });
      },
      () => {}
    );
  };

  performMerge = () => {
    if (!confirm('Are you sure you want to merge these accounts?  This cannot be undone!')) {
      return false;
    }

    const options = {
      user_to_merge_id: this.state.users[0][0].id,
      user_to_be_merged_into_id: this.state.users[1][0].id
    };
    this.setState({ statusText: 'Merge in progress...' });

    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/admin/users/${this.state.users[0][0].id}/merge`,
      options,
      data => {
        this.setState({
          statusText: 'Merge successful!',
          finalUser: data.users[0]
        });
      },
      data => {
        this.setState({ statusText: 'Merge failed.' });
      },
      () => {
        this.setState({ mergeComplete: true });
      }
    );
    return true;
  };

  containsBothUsers() {
    return this.state.users[0].length > 0 && this.state.users[1].length > 0;
  }

  resetFields = () => {
    this.setState({ emails: ['', ''], users: [[], []], mergeComplete: false, finalUser: null });
  };

  handleEmailChange = (index, e) => {
    const { emails } = this.state;
    emails[index] = e.target.value.trim();
    this.setState({ emails });
  };

  renderMergeButton() {
    let mergeButton = null;
    if (this.state.mergeComplete) {
      if (this.state.finalUser) {
        mergeButton = (
          <div className="user-info-centered">
            <div className="btn green rounded simple" disabled>
              MERGED
            </div>
          </div>
        );
      } else {
        mergeButton = (
          <div className="user-info-centered">
            <div className="btn orange rounded simple" disabled>
              MERGED
            </div>
          </div>
        );
      }
    } else if (this.mergeCheck()) {
      mergeButton = (
        <div className="user-info-centered">
          <button className="btn blue rounded simple" onClick={this.performMerge} type="button">
            MERGE
          </button>
        </div>
      );
    } else if (this.containsBothUsers()) {
      mergeButton = (
        <div className="user-info-centered">
          <button className="btn orange rounded simple" disabled type="button">
            CANNOT MERGE
          </button>
        </div>
      );
    }
    return mergeButton;
  }

  renderSimpleButton(onClick, text) {
    return (
      <div className="user-info-centered">
        <button className="btn brown rounded simple" onClick={onClick} type="button">
          {text}
        </button>
      </div>
    );
  }

  renderInfoHolder(index, labelText, float) {
    const findButtonBlock = (
      <button className="btn green rounded simple" onClick={() => this.retrieveUser(index)} type="button">
        Find User
      </button>
    );
    return (
      <div className={`${float} user-info-centered`}>
        <div>
          <label>{labelText}</label>
          <input
            value={this.state.emails[index]}
            onChange={e => this.handleEmailChange(index, e)}
            placeholder="Enter id, slug, or email for user here"
            className="email-inputs"
          />
        </div>
        {findButtonBlock}
        <AccountInfoHolder
          userIndex={index}
          performSave={this.performSave}
          performUndelete={this.performUndelete}
          userObjUpdated={this.userObjUpdated}
          users={this.state.users[index]}
        />
      </div>
    );
  }

  render() {
    const mergeButton = this.renderMergeButton();

    let statusText = null;
    if (this.state.statusText !== null) {
      statusText = <p className="user-info-centered feedback-text">{this.state.statusText}</p>;
    }

    let userLinkBlock = null;
    if (this.state.finalUser) {
      userLinkBlock = (
        <p className="user-info-centered feedback-text">
          Check out the end result{' '}
          <a href={`/members/${this.state.finalUser.slug}`} target="_blank" rel="noreferrer">
            here.
          </a>
        </p>
      );
    }

    const swapButton = this.containsBothUsers() ? this.renderSimpleButton(this.swapUsers, 'Swap') : null;
    const resetButton = this.state.users.flat().length > 0 ? this.renderSimpleButton(this.resetFields, 'Reset') : null;

    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="field clear contains-separator">
            {this.renderInfoHolder(0, 'Merge this account:', 'floatleft')}
            {this.renderInfoHolder(1, 'Into this account:', 'floatright')}
          </div>
        </div>
        <div>
          {mergeButton}
          {swapButton}
          {resetButton}
          {statusText}
          {userLinkBlock}
        </div>
      </div>
    );
  }
}

export default AccountMergeInterface;
